import { createStore } from "vuex";
import { db } from "@/firebase";
import { doc, getDoc, setDoc, collection } from "firebase/firestore";

export default createStore({
  state: {
    user: null,
    userRole: null, // 'visitor', 'IC', 'CI', 'admin'
    contentVisibilitySettings: {
      the10YearPlanCharacters: {
        cecilia: { enabled: true, visibility: "visitors" },
        patricia: { enabled: true, visibility: "visitors" },
        thePath: { enabled: true, visibility: "visitors" },
      },
      theArtefacts: { enabled: true, visibility: "visitors" },
      theApp: { enabled: true, visibility: "visitors" },
      theFilmProjects: { enabled: true, visibility: "visitors" },
      theCharacters: { enabled: true, visibility: "visitors" },
      epilogue: { enabled: true, visibility: "VIP" },
    },
  },
  getters: {
    isAdmin: (state) => state.userRole?.toLowerCase() === "admin",
    isCI: (state) => state.userRole?.toLowerCase() === "ci",
    isIC: (state) => state.userRole?.toLowerCase() === "ic",
    // Legacy getter for backwards compatibility
    isVIP: (state) => state.userRole?.toLowerCase() === "vip" || state.userRole?.toLowerCase() === "ic",
    isVisitor: (state) =>
      state.userRole?.toLowerCase() === "visitor" || state.userRole === null,
    contentVisibilitySettings: (state) => state.contentVisibilitySettings,
    canAccessContent:
      (state) =>
      (section, subsection = null) => {
        try {
          // Get the setting object
          let setting;
          if (subsection) {
            setting = state.contentVisibilitySettings[section]?.[subsection];
          } else {
            setting = state.contentVisibilitySettings[section];
          }

          // If setting doesn't exist or is disabled, only admins can see it
          if (!setting || !setting.enabled) {
            return state.userRole?.toLowerCase() === "admin";
          }

          // If visibility is "visitors", everyone can access
          if (setting.visibility?.toLowerCase() === "visitors") {
            return true;
          }

          // If visibility is "IC", IC, CI, and admins can access
          if (setting.visibility?.toLowerCase() === "ic") {
            const role = state.userRole?.toLowerCase();
            return role === "admin" || role === "ci" || role === "ic";
          }

          // If visibility is "CI", only CI and admins can access
          if (setting.visibility?.toLowerCase() === "ci") {
            const role = state.userRole?.toLowerCase();
            return role === "admin" || role === "ci";
          }

          // Legacy: "VIP" treated as equivalent to "IC"
          if (setting.visibility?.toLowerCase() === "vip") {
            const role = state.userRole?.toLowerCase();
            return role === "admin" || role === "ci" || role === "ic" || role === "vip";
          }

          // Default case - if we don't recognize the visibility setting
          return false;
        } catch (error) {
          return false;
        }
      },
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setUserRole(state, role) {
      state.userRole = role;
    },
    setContentVisibility(state, { section, subsection = null, setting }) {
      if (subsection) {
        state.contentVisibilitySettings[section][subsection] = setting;
      } else {
        state.contentVisibilitySettings[section] = setting;
      }
    },
    setContentVisibilitySettings(state, settings) {
      state.contentVisibilitySettings = settings;
    },
  },
  actions: {
    // We no longer need these actions as we're using direct Firestore access
    // through the useContent.js functions
  },
  modules: {},
});
